import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { Report } from '../../model/Report';
import { defined, evaluate } from '../../utility/Control';
import StringFormatter from '../../utility/StringFormatter';
import { CadastreHousingValueConveyance } from '../../model/CadastreHousingValueConveyance';

const tagProperties: string[] = ['calculationText', 'lastConveyanceDateRegistered', 'lastConveyancePurchasePrice'];

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    map(DataStore.getReport(), tag);
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
}

function map(report: Report, tag: any): void {
  tagProperties.forEach((tagProperty: string) => {
    tag[tagProperty] = undefined;
  });
  tag.calculationText = evaluate(report, 'housingValue.calculationText');
  const mostRecentFreeMarketConveyance: CadastreHousingValueConveyance = evaluate(
    report,
    'housingValue.mostRecentFreeMarketConveyance'
  );
  if (defined(tag.calculationText, mostRecentFreeMarketConveyance)) {
    const lastConveyanceDateRegistered: string = evaluate(mostRecentFreeMarketConveyance, 'dateRegistered.ddmmyyyy');
    const purchasePrice: number = mostRecentFreeMarketConveyance.purchasePrice;
    if (defined(lastConveyanceDateRegistered, purchasePrice)) {
      tag.lastConveyanceDateRegistered = lastConveyanceDateRegistered;
      tag.lastConveyancePurchasePrice = StringFormatter.formatMonetaryAmount(purchasePrice.toString());
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/calculationBasis/CalculationBasisMapper.ts
 **/